import { useContext } from "react";
import { UserContext } from "../userContext/userContext";
import useLogout from "../hooks/useLogout";
import '../App.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { NavLink } from "react-router-dom";

function HeaderHome() {
  const { userState } = useContext(UserContext);
  const isLogged = userState.isLogged;
  const logout = useLogout();

  return (
    <>
      <img src="/bandeau.jpg" className="banner-img" alt="Bandeau LSR 47" />
      <div className="App">
        <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect className="site-navbar">
          <Container fluid="lg" className="site-navbar-container">
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar" className="justify-content-center">
              <Nav className="site-nav">
                <Nav.Link as={NavLink} to="/home">Accueil</Nav.Link>
                <Nav.Link as={NavLink} to="/presentation">Qui sommes-nous?</Nav.Link>
                <Nav.Link as={NavLink} to="/galerie">Galerie</Nav.Link>
                <NavDropdown title="Evenements" id="nav-dropdown-evenements">
                  <NavDropdown.Item as={NavLink} to="/evenements/a-venir">
                    Evenements a venir
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/evenements/passes">
                    Evenements passes
                  </NavDropdown.Item>
                  <NavDropdown.Item as={NavLink} to="/evenements/external">
                    Que se passe-t-il ailleurs?
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link as={NavLink} to="/contact">Contact</Nav.Link>
                <Nav.Link as={NavLink} to="/login">Espace adherents</Nav.Link>
                {isLogged && (
                  <Nav.Link
                    onClick={logout}
                    href="/"
                  >
                    Deconnexion
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

export default HeaderHome;
